// Transitions
export const AMC_FORM_VALID_TRANSITION_OTHER_DETAILS = "allSureMotorClaim/transition/otherDetails/formValid";
export const AMC_FORM_INVALID_TRANSITION_OTHER_DETAILS = "allSureMotorClaim/transition/otherDetails/formInvalid";

export const transitionIncidentDetails = {
  formValid: () => ({ type: AMC_FORM_VALID_TRANSITION_OTHER_DETAILS }),
  formInvalid: () => ({ type: AMC_FORM_INVALID_TRANSITION_OTHER_DETAILS }),
};

// Input felid actions
export const AMC_OTHER_DETAILS = "allSureMotorClaim/otherDetails/";
export const AMC_OTHER_DETAILS_SET_VALUE = AMC_OTHER_DETAILS+"setValue/";
export const AMC_OTHER_DETAILS_SET_VALID = AMC_OTHER_DETAILS +"setValid/";

export const setOtherDetailsValue =(value)=>({type: AMC_OTHER_DETAILS_SET_VALUE, value})
export const setOtherDetailsFieldValid =(error,fieldType)=>({type: AMC_OTHER_DETAILS_SET_VALID, error, fieldType})

export const AMC_OTHER_DETAILS_SET_VALUE_WITHOUT_VALIDATION = AMC_OTHER_DETAILS+"withoutValidation/setValue";
export const setOtherDetailsWithoutValidation =(value)=>({type: AMC_OTHER_DETAILS_SET_VALUE_WITHOUT_VALIDATION, value})
